const deprecatedTextColors = new Set([
    'alert',
    'black',
    'black-800',
    'dark-grey',
    'dark-gray',
    'grey-700',
    'gray-700',
    'white'
]);
const deprecatedBackgroundColors = new Set([
    'atlantic',
    'black-900',
    'caspian',
    'celtic',
    'dark-blue',
    'dark-gray',
    'dark-grey',
    'discount',
    'emerald-100',
    'emerald-700',
    'emerald',
    'graphite',
    'gray-100',
    'gray-200',
    'gray-300',
    'gray-400',
    'gray-500',
    'gray-600',
    'gray-700',
    'gray-800',
    'gray-900',
    'green-100',
    'green-700',
    'grey-100',
    'grey-200',
    'grey-300',
    'grey-400',
    'grey-500',
    'grey-600',
    'grey-700',
    'grey-800',
    'grey-900',
    'iris',
    'kingfisher',
    'light-blue',
    'light-gray',
    'light-grey',
    'loading-shimmer',
    'mandarin',
    'medium-gray',
    'medium-green',
    'medium-grey',
    'medium-yellow',
    'opal',
    'platinum',
    'pumpkin',
    'rio',
    'rum',
    'santorini',
    'scarlet',
    'talavera',
    'ultramarine',
    'violet',
    'white',
    'white-900',
    'yellow-700'
]);
const allDeprecations = {
    bgc: {
        values: [
            ...deprecatedBackgroundColors
        ],
        message: 'Replace with an alternative, or use MARKETING_COLORS object for CMS integration.'
    },
    backgroundColor: {
        values: [
            ...deprecatedBackgroundColors
        ],
        message: 'Replace with an alternative, or use MARKETING_COLORS object for CMS integration.'
    },
    fontFamily: {
        values: [
            'special'
        ],
        message: 'This will be removed in the v3 release and will be available with the value secondary. Right now, no change is required. Just use our codemods when migrating to v3.'
    },
    fontSize: {
        values: [
            -2,
            -1,
            1,
            2,
            3,
            4,
            5,
            6,
            '-2',
            '-1',
            '1',
            '2',
            '3',
            '4',
            '5',
            '6',
            'xm2',
            'xm1',
            'x',
            'x0',
            'x1',
            'x2',
            'x3',
            'x4',
            'x5',
            'x6'
        ],
        message: 'Old scale sizes are deprecated. Use equivalent new scale size.'
    },
    fontWeight: {
        values: [
            'bolder'
        ],
        message: 'Use bold instead.'
    },
    textColor: {
        values: [
            ...deprecatedTextColors
        ],
        message: 'Replace with an alternative.'
    }
};
const warned = {};
function checkCorePropDeprecation(key, value, breakpoint) {
    if (process.env.NODE_ENV !== 'production') {
        const deprecations = allDeprecations[key];
        if (deprecations) {
            const propValue = typeof value === 'object' ? value[breakpoint] : value;
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore: propValue's warning is unnecessary.
            if (propValue && deprecations.values.includes(propValue) && !warned[`${key}-${propValue.toString()}`]) {
                var _allDeprecations_key;
                console.warn(`Deprecated \`${key}\` prop value: ${propValue}. ${((_allDeprecations_key = allDeprecations[key]) === null || _allDeprecations_key === void 0 ? void 0 : _allDeprecations_key.message) || ''}`);
                warned[`${key}-${propValue.toString()}`] = true;
            }
        }
    }
}

export { checkCorePropDeprecation };
